// @ts-nocheck

import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import './assets/css/App.css';


import { createBrowserHistory } from 'history';
import httpService from './services/interceptors';

import AuthLayout from './layouts/publico';
import AdminLayout from './layouts/privado';
import { ChakraProvider } from '@chakra-ui/react';

import AuthContextProvider from './contexts/authContext';

import theme from './theme/theme';

import { QueryClient, QueryClientProvider } from 'react-query'

import { PATH_PRIVADO, PATH_PUBLICO } from 'const/CommonConst'

const queryClient = new QueryClient()

const history = createBrowserHistory();
httpService.setupInterceptors(history);

ReactDOM.render(	
	<AuthContextProvider>
	<BrowserRouter>
    <QueryClientProvider client={queryClient}>
		<ChakraProvider theme={theme}>
			<React.StrictMode>
				<HashRouter>
					<Switch>
						<Route path={PATH_PUBLICO} component={AuthLayout} />
						<Route path={PATH_PRIVADO} component={AdminLayout} />
						<Redirect from='/' to={PATH_PRIVADO} />
					</Switch>
				</HashRouter>
			</React.StrictMode>
		</ChakraProvider>
	</QueryClientProvider>
  </BrowserRouter>
  </AuthContextProvider>,
	document.getElementById('root')
);
